import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import { snakeCase } from "lodash";

const styles = {
  dialogTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: 2,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  dialogContent: {
    paddingTop: 3,
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    px: 3,
    py: 2,
  },
};

export default function EditLaborRateDialog({ fieldInfo, onClose }) {
  const { values, setFieldValue } = useFormikContext();
  const [rateName, setRateName] = useState("");

  if (!fieldInfo) return null;

  const { key, name, baseName } = fieldInfo;
  
  React.useEffect(() => {
    if (rateName === "") {
      setRateName(name);
    }
  }, [name, rateName]);

  const handleRateNameChange = (event) => {
    setRateName(event.target.value);
  };

  const handleSave = () => {
    if (rateName.trim() && rateName !== name) {
      const label = rateName.trim();
      const pathParts = baseName.split(".");
      let current = values;
      for (const part of pathParts) {
        current = current?.[part];
      }
      const fieldData = current?.[key];

      if (fieldData) {
        const newKey = snakeCase(label);

        const newValue = { ...current };
        delete newValue[key];
        newValue[newKey] = {
          ...fieldData,
          label,
        };
        
        setFieldValue(baseName, newValue);
      }
    }
    onClose();
  };

  const handleDelete = () => {
    const pathParts = baseName.split(".");
    let current = values;
    for (const part of pathParts) {
      current = current?.[part];
    }
    const newValue = { ...current };
    delete newValue[key];
    setFieldValue(baseName, newValue);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography fontSize={24} fontWeight={500} color="textPrimary">
          Edit Rate
        </Typography>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Box>
          <Typography variant="subtitle2" gutterBottom>
            Rate Name
          </Typography>
          <TextField
            fullWidth
            value={rateName}
            onChange={handleRateNameChange}
            placeholder="Enter rate name"
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button color="error" variant="outlined" onClick={handleDelete}>
          Delete
        </Button>
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
